import type { Locale } from "@/lib/i18n/locales";

export const BUS_QUIZ_STORAGE_VERSION = 1;
export const BUS_QUIZ_PROGRESS_PREFIX = "bus-quiz:";
export const BUS_QUIZ_COMPLETION_PREFIX = "bus-quiz-complete:";
export const BUS_QUIZ_SCORE_PREFIX = "bus-quiz-score:";
export const BUS_QUIZ_MISTAKES_PREFIX = "bus-quiz-mistakes:";
export const BUS_QUIZ_CLEAR_EVENT = "bus-quiz-progress-cleared";

/** Preserve legacy English records; native attempts and generated versions are separate. */
export function quizStorageKeys(quizId: string, locale: Locale = "en", revision?: string) {
  const identity = locale === "en" ? quizId : `locale:${locale}:${quizId}`;
  const generated = quizId.startsWith("topic-") || quizId.startsWith("sec-g3-");
  const suffix = revision?.startsWith("generated-v1-") ? `${identity}:bank:${revision}` : generated ? `${identity}:bank:unversioned` : identity;
  return {
    progress: `${BUS_QUIZ_PROGRESS_PREFIX}${suffix}`,
    completion: `${BUS_QUIZ_COMPLETION_PREFIX}${suffix}`,
    score: `${BUS_QUIZ_SCORE_PREFIX}${suffix}`,
    mistakes: `${BUS_QUIZ_MISTAKES_PREFIX}${suffix}`,
  };
}

/** Only an explicit clear action uses this predicate; there is no data migration. */
export function quizStorageKeyBelongsToLocale(key: string, locale: Locale) {
  const prefix = [BUS_QUIZ_PROGRESS_PREFIX, BUS_QUIZ_COMPLETION_PREFIX, BUS_QUIZ_SCORE_PREFIX, BUS_QUIZ_MISTAKES_PREFIX].find(value => key.startsWith(value));
  if (!prefix) return false;
  const identity = key.slice(prefix.length);
  return locale === "en" ? !identity.startsWith("locale:") : identity.startsWith(`locale:${locale}:`);
}

/** Label language can differ from the language of an English fallback destination. */
export function quizProgressLocaleForHref(href: string): Locale {
  return href === "/zh" || href.startsWith("/zh/") || href === "/dev/mandarin-pilot" || href.startsWith("/dev/mandarin-pilot/") ? "zh-Hans" : "en";
}
